import { Box, ListItemButton, Stack } from "@mui/material";
import _ from "lodash";
import React, { useState, useMemo } from "react";

const Headings = ({ headings, activeId }) => 
  {
    return(

  <ul style={{ padding: 0 }}>
    {headings.map((heading) => (
      <li style={{ padding: '8px 12px' }} key={heading.id} className={heading.id === activeId ? "active" : ""}>
        <a
          style={{ paddingLeft: 4, paddingRight: 4 }}
          href={`#${heading.id}`}
          onClick={(e) => {
            e.preventDefault();
            document.querySelector(`#${heading.id}`).scrollIntoView({
              behavior: "instant"
            });
          }}
        >
          {heading?.title}
        </a>
        {heading?.items?.length > 0 && (
          <ul style={{ padding: 8 }}>
            {heading.items.map((child) => (
              <li
                style={{ padding: '4px 12px' }}
                key={child.id}
                className={child.id === activeId ? "active" : ""}
              >
                <a
                  style={{ paddingLeft: 4, paddingRight: 4 }}
                  href={`#${child.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(`#${child.id}`).scrollIntoView({
                      behavior: "instant"
                    });
                  }}
                >
                  {child?.title}
                </a>
              </li>
            ))}
          </ul>
        )}
      </li>
    ))}
  </ul>
)};

/**
 * Dynamically generates the table of contents list, using any H2s and H3s it can find in the main text
 */
const useHeadingsData = () => {
  const [nestedHeadings, setNestedHeadings] = React.useState([]);

  React.useEffect(() => {
    const headingElements = Array.from(
      document.querySelectorAll("main h2, main h3")
    );
    
    headingElements.forEach((headingElement, index) => {
      if (!headingElement.id) {
        headingElement.id = `heading-${index + 1}`;
      }
    });
   
    const newNestedHeadings = getNestedHeadings(headingElements);
    setNestedHeadings(newNestedHeadings);
  }, []);

  return { nestedHeadings };
};

const getNestedHeadings = (headingElements) => {
  const nestedHeadings = [];

  headingElements.forEach((heading) => {
    const { innerText: title, id } = heading;

    if (heading.nodeName === "H2") {
      nestedHeadings.push({ id, title, items: [] });
    } else if (heading.nodeName === "H3" && nestedHeadings.length > 0) {
      nestedHeadings[nestedHeadings.length - 1].items.push({
        id,
        title
      });
    }
  });

  
  const sortedNestedHeadings = nestedHeadings.map((headingElement) => {
    const sortedItems = _.orderBy(headingElement.items, ['title'], ['asc']);

    return {
      ...headingElement,
      items: sortedItems
    };
  });

  return _.orderBy(sortedNestedHeadings, ['title'], ['desc']);
};

const useIntersectionObserver = (setActiveId) => {
  const headingElementsRef = React.useRef({});
  React.useEffect(() => {
    const callback = (headings) => {
      headingElementsRef.current = headings.reduce((map, headingElement) => {
        map[headingElement.target.id] = headingElement;
        return map;
      }, headingElementsRef.current);

      
      const visibleHeadings = [];
      Object.keys(headingElementsRef.current).forEach((key) => {
        const headingElement = headingElementsRef.current[key];
        if (headingElement.isIntersecting) visibleHeadings.push(headingElement);
      });

      
      const headingElements = Array.from(document.querySelectorAll("main h2, main h3"));
      
      const getIndexFromId = (id) =>
        headingElements.findIndex((heading) => heading.id === id);

      if (visibleHeadings.length === 1) {
        setActiveId(visibleHeadings[0].target.id);
       
      } else if (visibleHeadings.length > 1) {
        const sortedVisibleHeadings = visibleHeadings.sort(
          (a, b) => getIndexFromId(a.target.id) - getIndexFromId(b.target.id)
        );

        setActiveId(sortedVisibleHeadings[0].target.id);
      }
    };

    
    const observer = new IntersectionObserver(callback, { 
      root: null, 
      rootMargin: "0px 0px -80% 0px", 
      threshold: 0.1
    });

    
    const headingElements = Array.from(document.querySelectorAll("main h2, main h3"));

    headingElements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [setActiveId]);
};

/**
 * Renders the table of contents.
 */
const TableOfContents = () => {
  const [activeId, setActiveId] = React.useState();
  const { nestedHeadings } = useHeadingsData();
  useIntersectionObserver(setActiveId);
  return (
    <nav aria-label="Table of contents">
      <Headings headings={nestedHeadings} activeId={activeId} />
    </nav>
  );
};

const DummyText =
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.";

const KeywordHelp = () => {
  return (
    <Stack direction={'row'} spacing={2} className="container toc" sx={{ height: 'calc(100vh - 200px)' }}>
      <Box sx={{ borderRight: '1px solid', borderColor: theme => theme.palette.divider, overflowY: 'auto', width: '20%' }}>
        <TableOfContents />
      </Box>
      <main style={{ overflowY: 'auto', paddingBottom: '600px', width: '80%' }}>
        <h2 id="old-format">Old Format</h2>
        <p>""</p>
        <h3>%BusinessType%</h3>
        <p>Restaurant</p>

        <h3>%CategoryTopicsWithExplanation%</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          Food:Taste [Any comments related to enjoyment or satisfaction][Any comments related to dissatisfaction with or lack of enjoyment with the food itself]<br></br>
          Food:Presentation<br></br>
          Food:Freshness<br></br>
          Food:Variety [Wide selection of dishes][Limited selection, lacks variety]<br></br>
          Food:Portion Size<br></br>
          Food:Other<br></br>
          Service:Staff [Friendly, courteous, welcoming staff][Rude, unprofessional, inattentive staff]<br></br>
          Service:Efficiency [Quick and timely service][Slow or delayed service]<br></br>
          Service:Knowledge [Staff well-informed about menu, restaurant][Staff lacks knowledge about menu, restaurant]<br></br>
          Service:Other<br></br>
          Atmosphere:Cleanliness<br></br>
          Atmosphere:Decor [Attractive, well-designed interior decor][Unattractive, outdated decor]<br></br>
          Atmosphere:Noise Level<br></br>
          Atmosphere:Space [Spacious, comfortable dining area][Cramped, uncomfortable dining space]<br></br>
          Atmosphere:Lighting<br></br>
          Atmosphere:Other<br></br>
          Value:Pricing<br></br>
          Value:Portion to Price Ratio<br></br>
          Value:Discounts and Offers<br></br>
          Value:Other<br></br>
          Location:Proximity [Conveniently located, easy to access][Inconveniently located, hard to access]<br></br>
          Location:Parking<br></br>
          Location:Experience [Positive feeling or experience associated with this location][Negative feeling or experience associated with this location]<br></br>
          Location:Other<br></br>
          Health, Safety, and Legal:Health [Adheres to health standards, feels safe][Experienced a health issue after eating food]<br></br>
          Health, Safety, and Legal:Safety [High safety standards, secure environment][Low safety standards, risky environment]<br></br>
          Health, Safety, and Legal:Legal [Compliant with legal requirements][Non-compliance with legal requirements or threatening legal action]<br></br>
          Health, Safety, and Legal:Other
        </p>

        <h3>%Company%</h3>
        <p>""</p>

        <h3>%CategoryAndTopics%</h3>
        <p>Food: Variety, Quality, Taste, Food<br></br>
          Service: Speed, Service, Parking, Staff, Friendliness, Delivery<br></br>
          Atmosphere: Ambience, Noise, Cleanliness, Experience<br></br>
          Value: Price, Portion Size, Value, Specials<br></br>
          Health, Safety and Legal: Health, Safety, Legal</p>

        <h3>%CategoryAndTopicsArray%</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          [<br></br>
          Food: Variety,Food: Quality,Food: Taste,Food: Food,Food: Other,<br></br>
          Service: Speed,Service: Service,Service: Parking,Service: Staff,Service: Friendliness,Service: Delivery,Service: Other,<br></br>
          Atmosphere: Ambience,Atmosphere: Noise,Atmosphere: Cleanliness,Atmosphere: Experience,Atmosphere: Other,<br></br>
          Value: Price,Value: Portion Size,Value: Value,Value: Specials,Value: Other,<br></br>
          Health, Safety and Legal: Health,Health, Safety and Legal: Safety,Health, Safety and Legal: Legal,Health, Safety and Legal: Other<br></br>
          ]</p>

        <h3>%CategorySentimentsArray%</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          ["Value:Negative","Food:Positive","Service:Negative"]
        </p>

        <h3>%CategoryTopicSentimentStrengthArray%</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          ["Value:Pricing:Negative:3","Food:Taste:Positive:5","Service:Staff:Negative:4"]
        </p>

        <h3>%CommaSeparatedTopics%</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          Safety, Variety, Specials, Delivery, Health, Safety and Legal, Price, Atmosphere, Value, Food, Health,
          Taste, Service, Legal, Cleanliness, Quality, Experience, Speed, Portion Size, Value, Ambience, Friendliness, Service, Food, Parking, Staff, Noise
        </p>

        <h2 id="new-format">New Format</h2>
        <p>""</p>
        <h3>{`{{AboutUs}}`}</h3>
        <p>""</p>
        <h3>{`{{Brand}}`}</h3>
        <p>""</p>
        <h3>{`{{BusinessName}}`}</h3>
        <p>""</p>
        <h3>{`{{BusinessType}}`}</h3>
        <p>Restaurant</p>
        <h3>{`{{CategoryAndTopics}}`}</h3>
        <p>Food: Variety, Quality, Taste, Food<br></br>
          Service: Speed, Service, Parking, Staff, Friendliness, Delivery<br></br>
          Atmosphere: Ambience, Noise, Cleanliness, Experience<br></br>
          Value: Price, Portion Size, Value, Specials<br></br>
          Health, Safety and Legal: Health, Safety, Legal</p>

        <h3>{`{{CategoryAndTopicsArray}}`}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          [<br></br>
          Food: Variety,Food: Quality,Food: Taste,Food: Food,Food: Other,<br></br>
          Service: Speed,Service: Service,Service: Parking,Service: Staff,Service: Friendliness,Service: Delivery,Service: Other,<br></br>
          Atmosphere: Ambience,Atmosphere: Noise,Atmosphere: Cleanliness,Atmosphere: Experience,Atmosphere: Other,<br></br>
          Value: Price,Value: Portion Size,Value: Value,Value: Specials,Value: Other,<br></br>
          Health, Safety and Legal: Health,Health, Safety and Legal: Safety,Health, Safety and Legal: Legal,Health, Safety and Legal: Other<br></br>
          ]</p>
        <h3>{`{{CategorySentimentsArray}}`}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          ["Value:Negative","Food:Positive","Service:Negative"]
        </p>
        <h3>{`{{CategoryTopicSentimentStrengthArray}}`}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          ["Value:Pricing:Negative:3","Food:Taste:Positive:5","Service:Staff:Negative:4"]
        </p>
        <h3>{`{{CategoryTopicsWithExplanation}}`}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          Food:Taste [Any comments related to enjoyment or satisfaction][Any comments related to dissatisfaction with or lack of enjoyment with the food itself]<br></br>
          Food:Presentation<br></br>
          Food:Freshness<br></br>
          Food:Variety [Wide selection of dishes][Limited selection, lacks variety]<br></br>
          Food:Portion Size<br></br>
          Food:Other<br></br>
          Service:Staff [Friendly, courteous, welcoming staff][Rude, unprofessional, inattentive staff]<br></br>
          Service:Efficiency [Quick and timely service][Slow or delayed service]<br></br>
          Service:Knowledge [Staff well-informed about menu, restaurant][Staff lacks knowledge about menu, restaurant]<br></br>
          Service:Other<br></br>
          Atmosphere:Cleanliness<br></br>
          Atmosphere:Decor [Attractive, well-designed interior decor][Unattractive, outdated decor]<br></br>
          Atmosphere:Noise Level<br></br>
          Atmosphere:Space [Spacious, comfortable dining area][Cramped, uncomfortable dining space]<br></br>
          Atmosphere:Lighting<br></br>
          Atmosphere:Other<br></br>
          Value:Pricing<br></br>
          Value:Portion to Price Ratio<br></br>
          Value:Discounts and Offers<br></br>
          Value:Other<br></br>
          Location:Proximity [Conveniently located, easy to access][Inconveniently located, hard to access]<br></br>
          Location:Parking<br></br>
          Location:Experience [Positive feeling or experience associated with this location][Negative feeling or experience associated with this location]<br></br>
          Location:Other<br></br>
          Health, Safety, and Legal:Health [Adheres to health standards, feels safe][Experienced a health issue after eating food]<br></br>
          Health, Safety, and Legal:Safety [High safety standards, secure environment][Low safety standards, risky environment]<br></br>
          Health, Safety, and Legal:Legal [Compliant with legal requirements][Non-compliance with legal requirements or threatening legal action]<br></br>
          Health, Safety, and Legal:Other
        </p>
         <h3>{`{{ChatData}}`}</h3>
         <p>""</p>
        <h3>{`{{Closing}}`}</h3>
        <p>""</p>
        <h3>{`{{CompanyName}}`}</h3>
        <p>""</p>
        <h3>{`{{CommaSeparatedTopics}}`}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>
          Safety, Variety, Specials, Delivery, Health, Safety and Legal, Price, Atmosphere, Value, Food, Health,
          Taste, Service, Legal, Cleanliness, Quality, Experience, Speed, Portion Size, Value, Ambience, Friendliness, Service, Food, Parking, Staff, Noise
        </p>
        <h3>{`{{Company}}`}</h3>
        <p>""</p>

        <h3>{`{{CustomFields}}`}</h3>
        <p>""</p>
        <h3>{`{{Context}}`}</h3>
        <p>""</p>
        <h3>{`{{ContactInfo}}`}</h3>
        <p>""</p>
        <h3>{`{{ContactPhrase}}`}</h3>
        <p>""</p>
        <h3>{`{{Facts}}`}</h3>
        <p>Fact 1: If the sentiment of the Review includes a negative Category sentiment for Food or Service and the rating is 3 or less, add to the response some language that reflect that they should consider contacting us at satisfaction@pterrys.com so that we can try to make it right, or give us another chance, etc.</p>
        <h3>{`{{FactsArray}}`}</h3>
        <p>[""]</p>
        <h3>{`{{Greeting}}`}</h3>
        <p>""</p>
        <h3>{`{{Location}}`}</h3>
        <p>""</p>
        <h3>{`{{NumberAndTextArray}}`}</h3>
        <p>{`[{"Number":1,"Text":""}]`}</p>
        <h3>{`{{Phrase1}}`}</h3>
        <p>""</p>
        <h3>{`{{Phrase2}}`}</h3>
        <p>""</p>
        <h3>{`{{Phrase3}}`}</h3>
        <p>""</p>
        <h3>{`{{Phrases}}`}</h3>
        <p>""</p>
        <h3>{`{{PreviousRating}}`}</h3>
        <p>"5"</p>
        <h3>{`{{PreviousReview}}`}</h3>
        <p>""</p>
        <h3>{`{{Rating}}`}</h3>
        <p>"5"</p>
        <h3>{`{{RedFlagInputData}}`}</h3>
        <p>""</p>
        <h3>{`{{ResponseLanguage}}`}</h3>
        <p>""</p>
        <h3>{`{{Response}}`}</h3>
        <p>""</p>
        <h3>{`{{ReviewRequestInstructions}}`}</h3>
        <p>""</p>
        <h3>{`{{ReviewerName}}`}</h3>
        <p>""</p>
        <h3>{`{{Review}}`}</h3>
        <p>""</p>

        <h3>{`{{SelectedReview}}`}</h3>
        <p>"Review text here"</p>
        <h3>{`{{Tones}}`}</h3>
        <p>Professional and Polite</p>
        <h3>{`{{TranslationLanguage}}`}</h3>
        <p>""</p>
        <h3>{`{{Voice}}`}</h3>
        <p>"Thank you for your review."</p>
        <h3>{`{{WordLength}}`}</h3>
        <p>100</p>
        <h3>{`{{ReviewsForFactDevelopment}}`}</h3>
        <p>""</p>
        <h3>{`{{TotalReviewsWithText}}`}</h3>
        <p>""</p>
        <h3>{`{{UpperBoundPct}}`}</h3>
        <p>""</p>
        <h3>{`{{DeterminedFirstName}}`}</h3>
        <p>""</p>
        <h3>{`{{WebsiteResearch}}`}</h3>
        <p>""</p>
        <h3>{`{{RelevantFacts}}`}</h3>
        <p>""</p>
        <h3>{`{{RequesterBusinessName}}`}</h3>
        <p>""</p>
        <h3>{`{{ReviewLanguage}}`}</h3>
        <p>""</p>
        <h3>{`{{InappropriateInstructions}}`}</h3>
        <p>""</p>
        <h3>{`{{ReviewClassification}}`}</h3>
        <p>""</p>
        <h3>{`{{PHIInstances}}`}</h3>
        <p>""</p>
        <h3>{`{{PHIAlert}}`}</h3>
        <p>""</p>
      </main>


    </Stack>
  );
};

// const KeywordHelp = ({ }) => {
//   return (
//     <div style={{ height: 'calc(100vh - 257px)', overflow: 'auto' }}>
//       <p><b>%BusinessType%</b></p>
//       <p>Restaurant</p>

//       <p><b>%CategoryAndTopics%</b></p>
//       <p>
//         Food: Variety, Quality, Taste, Food<br></br>
//         Service: Speed, Service, Parking, Staff, Friendliness, Delivery<br></br>
//         Atmosphere: Ambience, Noise, Cleanliness, Experience<br></br>
//         Value: Price, Portion Size, Value, Specials<br></br>
//         Health, Safety and Legal: Health, Safety, Legal</p>

//       <p><b>%CategoryAndTopicsArray%</b></p>
//       <p style={{ whiteSpace: 'pre-line' }}>
//         [<br></br>
//         Food: Variety,Food: Quality,Food: Taste,Food: Food,Food: Other,<br></br>
//         Service: Speed,Service: Service,Service: Parking,Service: Staff,Service: Friendliness,Service: Delivery,Service: Other,<br></br>
//         Atmosphere: Ambience,Atmosphere: Noise,Atmosphere: Cleanliness,Atmosphere: Experience,Atmosphere: Other,<br></br>
//         Value: Price,Value: Portion Size,Value: Value,Value: Specials,Value: Other,<br></br>
//         Health, Safety and Legal: Health,Health, Safety and Legal: Safety,Health, Safety and Legal: Legal,Health, Safety and Legal: Other<br></br>
//         ]</p>

//       <p><b>%CommaSeparatedTopics%</b></p>
//       <p style={{ whiteSpace: 'pre-line' }}>

//         Safety, Variety, Specials, Delivery, Health, Safety and Legal, Price, Atmosphere, Value, Food, Health,
//         Taste, Service, Legal, Cleanliness, Quality, Experience, Speed, Portion Size, Value, Ambience, Friendliness, Service, Food, Parking, Staff, Noise
//       </p>

//       <p>""</p>
//       <p><b>%Example%</b></p>
//       <p>Review 1: Their burgers are great. For a fast food restaurant, their burgers rock, and you can't beat the price. The lady at the drive-through is very friendly and does a great job, too. </p>
//       <p>Response: Thanks for the kind words, Jeremiah! We look forward to your next visit!</p >

//       <p><b>%ExampleResponseArray%</b></p>
//       <p>[""]</p>

//       <p><b>%ExampleResponseWithReviewerNameArray%</b></p>
//       <p>
//         {`[{
//           ReviewerName:"",
//           Response:""
//           }]`}
//       </p>

//       <p><b>%Facts%</b></p>
//       <p>Fact 1: If the sentiment of the Review includes a negative Category sentiment for Food or Service and the rating is 3 or less, add to the response some language that reflect that they should consider contacting us at satisfaction@pterrys.com so that we can try to make it right, or give us another chance, etc.</p>

//       <p><b>%FactsArray%</b></p>
//       <p>[""]</p>

//       <p><b>%NumberAndTextArray%</b></p>
//       <p>{`[{
//       "Number":1,
//       "Text":""
//       }]`}</p>

//       <p><b>%ReviewerName%</b></p>
//       <p>""</p>

//       <p><b>%Review%</b></p>
//       <p>""</p>

//       <p><b>%SelectedReview%</b></p>
//       <p>4cf600e4-edbe-47ea-afed-39232d937306: I ordered my food, drove around to the window…and sat there and waited 15 minutes while nobody came to the window.  When they finally did they tried to give me the wrong food.  The girl that was helping be was about as smart as a bag of socks, with evel less personality and social skills.  Then she just wandered off like Joe Biden after a speech.  I finally just had to leave because the level of stupid they were giving off was hurting my brain.</p>
//     </div>

//   )
// }
export default KeywordHelp
